<template>
  <div class="add-fields-modal">
    <a-modal
      title="查看企业信息"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleCancel"
      @cancel="handleCancel"
      width="800px"
      :centered="true"
      :footer="null"
    >
      <div>
        <a-table
        :columns="columns"
        :row-key="(record, index) => record.id"
        :data-source="data"
        :pagination="pagination"
        size="small"
        :loading="loading"
        @change="handleTableChange"
      >
        <template slot="index" slot-scope="text, record, index">
          <span>{{index + 1}}</span>
        </template>
        <template slot="sendRst" slot-scope="text, record, index">
          <span>{{record.sendRstInfo.feishuEmailCheck ? '飞书发送' : ''}} </span>
          <span>{{record.sendRstInfo.emailCheck ? '邮件发送' : ''}}</span>
        </template>
        <template slot="feishuEmailCheck" slot-scope="text, record, index">
          <template v-if="record.sendRstInfo.feishuEmailCheck">
            <div>
              成功 
              <a-popover>
                <template slot="content">
                  <p v-for="item in record.sendRstInfo.feishuSend.success">
                    <span>{{item.email}}: </span><span>{{item.msg}}</span>
                  </p>
                </template>
                <tag color="#4278FF" style="color: #4278FF">{{record.sendRstInfo.feishuSend.success.length}} </tag>
                <span>个</span>
              </a-popover>             
              失败
              <a-popover>
                <template slot="content">
                  <p v-for="item in record.sendRstInfo.feishuSend.fail">
                    <span>{{item.email}}: </span><span>{{item.msg}}</span>
                  </p>
                </template>
                <tag color="#4278FF" style="color: #4278FF">{{record.sendRstInfo.feishuSend.fail.length}} </tag>
                <span>个</span>
              </a-popover>                 
            </div>
          </template>
        </template>
        <template slot="emailCheck" slot-scope="text, record, index">
          <template v-if="record.sendRstInfo.emailCheck">
            <div>
              成功
              <a-popover>
                <template slot="content">
                  <p v-for="item in record.sendRstInfo.emailSend.success">
                    <span>{{item.email}}: </span><span>{{item.msg}}</span>
                  </p>
                </template>
                <tag color="#4278FF" style="color: #4278FF">{{record.sendRstInfo.emailSend.success.length}} </tag>
                <span>个</span>
              </a-popover>                   
              <!-- <span>{{record.sendRstInfo.emailSend.success.length}}个 </span> -->
              失败        
              <a-popover overlayClassName="use-popover">
                <template slot="content">
                  <p v-for="item in record.sendRstInfo.emailSend.fail">
                    <span>{{item.email}}: </span><span>{{item.msg}}</span>
                  </p>
                </template>
                <tag color="#4278FF" style="color: #4278FF">{{record.sendRstInfo.emailSend.fail.length}} </tag>
                <span>个</span>
              </a-popover>      
              <!-- <span>{{record.sendRstInfo.emailSend.fail.length}}个 </span> -->
            </div>
          </template>
        </template>
      </a-table>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { getEnterpriseUsers } from "@/api/shareModal"
const columns = [
	// {
	// 	title: '序号',
	// 	dataIndex: 'id',
	// 	width: 55,
	// 	align: 'left',
	// 	scopedSlots: { customRender: 'index' },
	// },
	{
		title: '用户名称',
		dataIndex: 'userName',
		align: 'left',
    ellipsis: true,
		width: 120,
    scopedSlots: { customRender: 'userName' },
	},
	{
		title: '用户邮箱',
		dataIndex: 'loginName',
		align: 'left',
    ellipsis: true,
		width: 120,
    scopedSlots: { customRender: 'loginName' },
	},
]
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      loading: false,
      pagination: {
				current: 1,
				total: 0,
				pageSize: 10,
        showTotal: total => `共${total}条`
			},
			data: [],
			columns,
      
    };
  },
  props: ['id'],
  watch:{
    visible(val){
      if(val){
        this.getList();
      }
    }
  },
  mounted() {
    // this.getList();
  },
  methods: {
   getList() {
      this.loading = true
      const params = {
        pageSize: this.pagination.pageSize,
        pageNo: this.pagination.current,
        corporationCode: this.id
        // corporationCode: 'Q000001'
      }
      getEnterpriseUsers(params).then((res) => {
        this.data = res.data || []
        // this.pagination.total = res.data.recordCount
      }).finally(() => this.loading = false)
    },
    handleTableChange(pagination) {
			let pager = { ...this.pagination };
			pager.current = pagination.current;
			this.pagination = pager;
			this.getList()
		},
   
    handleOk(e) {
      
    },
   
    handleCancel(e) {
      
      this.visible = false;
    },
    

  },
  
};
</script>
<style lang="less" scoped>
.division-title {
  text-align: left;
  line-height: 40px;
  padding-right: 10px;
}
.use-popover{
  // background: #f90;
}
</style>